module.exports = __webpack_public_path__ + "img/pre4-celular.629dcdfd.jpg";